import domek1 from "./DSC7685.webp";
import domek2 from "./DSC7692.webp";
import domek3 from "./DSC7702.webp";
import domek4 from "./domek.webp";
import domek5 from "./DSC_8866-1.webp";
import domek6 from "./DSC_8877.webp";
import domek7 from "./DSC_8882.webp";
import domek8 from "./domek_wiatr_niedzica1.webp";
import domek9 from "./domek_wiatr_niedzica2.webp";
import domek10 from "./domek_woda_niedzica2.webp";
import domek11 from "./domek_wiatr.webp"
import domek12 from "./domek_woda_niedzica5.webp";
import domek13 from "./domek_woda_niedzica6.webp";
import domek14 from "./domek_woda_niedzica7.webp";
import domek15 from "./domek_woda_niedzica8.webp";
import domek16 from "./domek_woda_niedzica9.webp";

export const housesImages = [domek1, domek2, domek3, domek4, domek5, domek6, domek7, domek8, domek9, domek10, domek11, domek12, domek13, domek14, domek15, domek16];